

















































import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { IMenuItem, IMenuLink } from "../..";
import EventsPanel from "./_EventsPanel.vue";
import { NavigationState } from '../../store';
import { namespace } from 'vuex-class';
const navigationState = namespace(NavigationState.name);

@Component({
    components: {
        EventsPanel,
    },
})
export default class SecondLevelMenuItem extends Vue {
    @Prop({ default: () => [] }) public itemData: IMenuLink;
    @Prop({ required: true }) public itemIndex: number;

    @navigationState.Getter activeSecondLevelIndex: number | null;
    @navigationState.Action closeEventsLevel: () => void;
    @navigationState.Action setActiveSecondLevelItem: (itemIndex: number) => void;

    public get showEventsPanel(): boolean {
        return !!this.itemData.events && this.itemIndex === this.activeSecondLevelIndex;
    }

    public toggleEventsPanel(): void {
        // If you're clicking a currently active item with open panel, close it
        if (this.activeSecondLevelIndex === this.itemIndex) {
            this.closeEventsLevel();
        } else if(!!this.itemData.events){
            this.setActiveSecondLevelItem(this.itemIndex);
        }
    }

    additionalClassesForItem(item: IMenuLink){
        return {
            ['sip-modal']: !!item?.modal,
            ['sip-link']: !!item,
        }
    }

    navigateAction(e: Event, item: IMenuLink) {
        if (!!item?.modal) {
            e.preventDefault();
            this.navigate(e);
        }
    }

    @Emit('navigate') public navigate(e: Event) { return e; }
    public destroyed() { NavigationState.unregister?.(this.$store); }
    public beforeCreate() { NavigationState.register?.(this.$store); }
}
